import React from "react";
import { useState } from "react";
import cx from "classnames";
import { Button } from "reactstrap";
import { connect } from "react-redux";
import { useEffect } from "react";
import PropTypes from "prop-types";
import {
  setBlogToEdit,
  getOneNewsByKey,
  setIsLoading,
} from "../../reduxSetup/action";
import getDecodeDescription from "../../services/decodeText";
import { addNewsAPI } from "../../services/api";
import {
  checkIsValidForm,
  updateErrorsForm,
} from "../../services/manageValidation";
import {
  getSelected,
  getButtonText,
  handleFieldChange,
} from "../../services/filters";
import { TextField } from "../../components/TextField/TextField";
import DropDown from "../../containers/DropDown/DropDown";
import { ModalConsumer } from "../../common/ModalContext";
import ModalAdditionResult from "../../components/ModalAdditionResult/ModalAdditionResult";
import FormGetItemByKey from "../../components/FormGetItemByKey/FormGetItemByKey";
import COUNTRIES from "../../constants/countries";
import { validateURL } from "../../services/validateURL";
import ModalWithDropDown from "../../components/ModalWithDropDown/ModalWithDropDown";
import { getSearchOptions } from "../../services/getSearchOptions";
import styles from "./AddBlog.module.scss";
import FIELDS_BLOG from "../../constants/blog";

const initialState = {
  title: "",
  body: "",
  photo: "",
  photoSource: "",
  titleSeo: "",
  descriptionSeo: "",
  countries: [],
  blogFields: [],
};
const AddBlog = ({
  setIsLoading,
  email,
  getOneNewsByKey,
  setBlogToEdit,
  blogToEdit,
}) => {
  const [state, setState] = useState(initialState);
  const [error, setError] = useState("");
  const [validationError, setValidationError] = useState([]);
  const [blogKey, setBlogKey] = useState("");

  useEffect(() => {
    if (!blogToEdit || !blogToEdit.length) {
      return;
    }
    const oneNewsToEdit = blogToEdit[0];
    setState((newsData) => ({
      ...newsData,
      title: oneNewsToEdit?.title,
      countries: [oneNewsToEdit?.country],
      blogFields: [oneNewsToEdit?.field],
      body: getDecodeDescription(oneNewsToEdit?.body),
      photo: oneNewsToEdit?.photo,
      key: oneNewsToEdit?.key,
      photoSource: oneNewsToEdit?.photoSource,
      titleSeo: oneNewsToEdit?.titleSeo,
      descriptionSeo: oneNewsToEdit?.descriptionSeo,
    }));
  }, [blogToEdit]);

  const handleSubmit = async ({ event, toggleModal }) => {
    event.preventDefault();
    const data = { ...state };
    data.type = "blog";
    if (!checkIsValidForm({ state: data })) {
      updateErrorsForm({ state: data, setValidationError });
      return;
    }
    addNews(toggleModal);
  };

  const addNews = async (toggleModal) => {
    setIsLoading(true);
    try {
      const response = await addNewsAPI({
        article: {
          title: state.title,
          body: encodeURIComponent(state.body),
          photo: state.photo,
          author: email,
          field: state.blogFields[0],
          country: state.countries[0],
          key: state.key,
          photoSource: state.photoSource,
          titleSeo: state.titleSeo,
          descriptionSeo: state.descriptionSeo,
        },
        type: "blog",
      });
      if (!response || response.status !== 200) {
        throw new Error("Something went wrong");
      }

      clearAll();
      setBlogKey("");
      toggleModal();
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const clearAll = () => {
    setState(initialState);
    setBlogToEdit(false);
  };

  const handleChange = (e) => {
    const value = e.target.value;
    const name = e.target.name;

    setState((state) => ({
      ...state,
      [name]: value,
    }));

    if (name === "photo") {
      validateURL(value) &&
        cancelValidationError(name, setValidationError, validationError);
    } else {
      value.length &&
        cancelValidationError(name, setValidationError, validationError);
    }
  };

  const dropDownSelect = (value, name) => {
    setState((state) => ({
      ...state,
      [name]: [value],
    }));
    value.length &&
      cancelValidationError(name, setValidationError, validationError);
  };
  const getChangeValue = (modalId, value) => {
    switch (modalId) {
      case "countries":
        setState((prev) => ({ ...prev, countries: value }));
        break;
      case "blogFields":
        setState((prev) => ({ ...prev, blogFields: value }));
        break;
    }
  };
  const checkTitleLength = (e) => {
    handleChange(e);
  };
  const cancelValidationError = (filterType) => {
    // MOVE TO SERVICES?
    setValidationError(
      validationError.filter((errorItem) => errorItem !== filterType)
    );
  };
  const changeValidationError = (filterType) => {
    // MOVE TO SERVICES?
    setValidationError(
      validationError.filter((errorItem) => errorItem !== filterType)
    );
  };
  return (
    <div className={styles.addNew}>
      <h1 className={styles.addNewTitle}>Add Blog</h1>
      <FormGetItemByKey
        itemKey={blogKey}
        type="blog"
        setItemKey={setBlogKey}
        getItemToEdit={getOneNewsByKey}
      />

      <ModalConsumer>
        {({ isOpen, toggleModal }) => (
          <>
            <ModalAdditionResult
              toggleModal={toggleModal}
              isOpen={isOpen}
              content="You've added a blog"
            />
            <form
              onSubmit={(event) => handleSubmit({ event, toggleModal })}
              className={styles.addNewForm}
            >
              <TextField
                label="Title*"
                placeholder="Title"
                name="title"
                handleChange={checkTitleLength}
                value={state.title}
                validationError={state.validationError}
                className={cx({
                  [styles.inputError]: validationError.includes("title"),
                })}
              />
              <p
                className={cx(styles.errorLabel, {
                  "d-block": validationError.includes("title"),
                })}
              >
                {("error", "Please, write title")}
              </p>
              <div className={styles.dropDownContainer}>
                <div className={cx(styles.dropDown, styles.dropDownDesktop)}>
                  <p className={styles.fieldLabel}>Country*</p>
                  <DropDown
                    name="countries"
                    changeValidationError={changeValidationError}
                    className={styles.autocomplete}
                    onChange={dropDownSelect}
                    selected={state.countries}
                    onClear={() => dropDownSelect([], "countries")}
                    dropDownErrorClass={
                      validationError.includes("countries") &&
                      styles.dropDownError
                    }
                    options={COUNTRIES}
                    buttonText={getButtonText(
                      state.countries,
                      "Countries",
                      "countries"
                    )}
                  />
                  <p
                    className={cx(styles.errorLabel, {
                      "d-block": validationError.includes("countries"),
                    })}
                  >
                    {("error", "Please, choose countries")}
                  </p>
                </div>
                <div className={cx(styles.dropDown, styles.dropDownDesktop)}>
                  <p className={styles.fieldLabel}>Fields*</p>
                  <DropDown
                    name="blogFields"
                    className={styles.autocomplete}
                    changeValidationError={changeValidationError}
                    onChange={dropDownSelect}
                    selected={state.blogFields}
                    onClear={() => dropDownSelect([], "blogFields")}
                    dropDownErrorClass={
                      validationError.includes("blogFields") &&
                      styles.dropDownError
                    }
                    options={FIELDS_BLOG}
                    buttonText={getButtonText(
                      state.blogFields,
                      "Fields",
                      "blogFields"
                    )}
                  />
                  <p
                    className={cx(styles.errorLabel, {
                      "d-block": validationError.includes("blogFields"),
                    })}
                  >
                    {("error", "Please, choose fields")}
                  </p>
                </div>
              </div>
              <div className={styles.dropDownMobile}>
                <ModalConsumer>
                  {({ toggleModal }) => (
                    <>
                      <p
                        className={cx(styles.fieldLabel, {
                          [styles.labelError]:
                            validationError.includes("countries"),
                        })}
                      >
                        Countries*
                      </p>
                      <Button
                        onClick={() => {
                          toggleModal("countries");
                        }}
                        className={cx(
                          styles.filterButton,
                          {
                            [styles.dropDownError]:
                              validationError.includes("countries"),
                          },
                          state.countries.length
                            ? styles.labelValue
                            : styles.labelName
                        )}
                      >
                        {getButtonText(
                          state.countries,
                          "Countries",
                          "countries"
                        )}
                      </Button>
                    </>
                  )}
                </ModalConsumer>
              </div>
              <div className={styles.dropDownMobile}>
                <ModalConsumer>
                  {({ toggleModal }) => (
                    <>
                      <p
                        className={cx(styles.fieldLabel, {
                          [styles.labelError]:
                            validationError.includes("blogFields"),
                        })}
                      >
                        Fields*
                      </p>
                      <Button
                        onClick={() => {
                          toggleModal("blogFields");
                        }}
                        className={cx(
                          styles.filterButton,
                          {
                            [styles.dropDownError]:
                              validationError.includes("blogFields"),
                          },
                          state.blogFields.length
                            ? styles.labelValue
                            : styles.labelName
                        )}
                      >
                        {getButtonText(
                          state.blogFields,
                          "Fields",
                          "blogFields"
                        )}
                      </Button>
                    </>
                  )}
                </ModalConsumer>
              </div>
              <TextField
                label="Body*"
                placeholder="Body"
                name="body"
                handleChange={handleChange}
                value={state.body}
                validationError={state.validationError}
                className={cx({
                  [styles.inputError]: validationError.includes("body"),
                })}
              />
              <p
                className={cx(styles.errorLabel, {
                  "d-block": validationError.includes("body"),
                })}
              >
                {("error", "Please, write body")}
              </p>
              <TextField
                label="Photo URL*"
                placeholder="Photo URL"
                name="photo"
                handleChange={handleChange}
                value={state.photo}
                validationError={state.validationError}
                className={cx({
                  [styles.inputError]: validationError.includes("photo"),
                })}
              />
              <p
                className={cx(styles.errorLabel, {
                  "d-block": validationError.includes("photo"),
                })}
              >
                {("error", "Please, write photo (valid URL)")}
              </p>
              <TextField
                label="Photo Source*"
                placeholder="Photo URL"
                name="photoSource"
                handleChange={handleChange}
                value={state.photoSource}
                validationError={state.validationError}
                className={cx({
                  [styles.inputError]: validationError.includes("photoSource"),
                })}
              />

              <p className={styles.title}>SEO</p>
              <div className={cx(styles.formItem)}>
                <TextField
                  name="titleSeo"
                  placeholder="Title SEO"
                  value={state.titleSeo}
                  handleChange={handleChange}
                  isTextArea
                />
              </div>
              <div className={styles.textareaContainer}>
                <TextField
                  type="textarea"
                  name="descriptionSeo"
                  placeholder="Description SEO"
                  handleChange={handleChange}
                  value={state.descriptionSeo}
                  isTextArea
                />
              </div>

              <div className={styles.addNewButtonContainer}>
                <button
                  className={styles.addNewButton + " " + styles.addNewButtonAdd}
                  type="submit"
                >
                  Add
                </button>
                <button
                  onClick={clearAll}
                  className={
                    styles.addNewButton + " " + styles.addNewButtonClear
                  }
                  type="button"
                >
                  Clear All
                </button>
              </div>
            </form>
          </>
        )}
      </ModalConsumer>
      <ModalConsumer>
        {({ isOpen, toggleModal, modalId }) => {
          return (
            modalId === "countries" && (
              <ModalWithDropDown
                onSave={toggleModal}
                toggleModal={toggleModal}
                isOpen={isOpen}
                name={modalId}
                options={COUNTRIES}
                selected={getSelected({
                  modalId,
                  countries: state.countries,
                })}
                onChange={handleFieldChange.bind({
                  filter: modalId,
                  changeFilter: (value) => getChangeValue(modalId, value),
                  selected: getSelected({
                    modalId,
                    countries: state.countries,
                  }),
                  cancelValidationError: cancelValidationError,
                })}
                onClear={() => getChangeValue(modalId, [])}
                changeValidationError={changeValidationError}
              />
            )
          );
        }}
      </ModalConsumer>
      <ModalConsumer>
        {({ isOpen, toggleModal, modalId }) => {
          return (
            modalId === "blogFields" && (
              <ModalWithDropDown
                onSave={toggleModal}
                toggleModal={toggleModal}
                isOpen={isOpen}
                name={modalId}
                options={getSearchOptions(modalId)}
                selected={getSelected({
                  modalId,
                  blogFields: state.blogFields,
                })}
                onChange={handleFieldChange.bind({
                  filter: modalId,
                  changeFilter: (value) => getChangeValue(modalId, value),
                  selected: getSelected({
                    modalId,
                    blogFields: state.blogFields,
                  }),
                  cancelValidationError: cancelValidationError,
                })}
                onClear={() => getChangeValue(modalId, [])}
                changeValidationError={changeValidationError}
              />
            )
          );
        }}
      </ModalConsumer>
    </div>
  );
};
AddBlog.propTypes = {
  updateIsLoading: PropTypes.func,
  email: PropTypes.string,
};

const mapDispatchToProps = {
  setIsLoading,
  getOneNewsByKey,
  setBlogToEdit,
};

const mapStateToProps = ({ news, user: { email } }) => {
  const { blogToEdit } = news;
  return {
    blogToEdit,
    email,
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(AddBlog);
